<template>
  <div class="select_line_style">
    <p>{{ label }}</p>
    <div class="content">
      <span>{{ activeTitle }}</span>
      <div>
        <div
          v-for="item of list"
          :key="item.type"
          :class="{ active: value === item.type, [item.type]: true }"
          @click="$emit('input', item.type)"
        >
          <div></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      default: ""
    },
    label: {
      type: String,
      default: ""
    }
  },
  computed: {
    activeTitle() {
      return this.list.find(item => item.type === this.value).title;
    }
  },
  data() {
    return {
      list: [
        {
          title: "实线",
          type: "solid"
        },
        {
          title: "虚线",
          type: "dashed"
        },
        {
          title: "圆点",
          type: "dotted"
        }
      ]
    };
  }
};
</script>

<style lang="less" scoped>
.select_line_style {
  display: flex;
  align-items: center;
  justify-content: space-between;
  > p {
    font-weight: 400;
    font-size: 12px;
    color: #999999;
  }
  .content {
    display: flex;
    align-items: center;
    > span {
      font-weight: 400;
      font-size: 12px;
      color: #333333;
    }
    > div {
      display: flex;
      align-items: center;
      margin-left: 10px;
      > div {
        display: flex;
        flex-direction: column;
        border: 1px solid #eeeeee;
        width: 60px;
        height: 32px;
        cursor: pointer;
        align-items: center;
        justify-content: center;
        padding: 0 20px;
        > div {
          width: 35px;
        }
      }
      > .solid {
        > div {
          border-top: 1px solid #c5c5c5;
        }
      }
      > .dashed {
        > div {
          border-top: 1px dashed #c5c5c5;
        }
      }
      > .dotted {
        > div {
          border-top: 1px dotted #c5c5c5;
        }
      }

      > .active {
        background: #ecf4ff;
        border: 1px solid #2154f4;
        > div {
          border-color: #2154f4;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/myviews/shoppMall/activityPageSet/fullPlatformSetQuery/lowCode/custom-component/baseComponents/Divider/components/SelectLineStyle.vue